import React, { useState } from "react";
import './UserPlanStyle.css';
import CurrentPlan from './CurrentPlan';
import CurrentPlanMoreInfoDetails from './CurrentPlanMoreInfoDetails';

import {useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { info } from "../../assets/icons";

const Render_PlanCubeCard = ({isPlanShow, setIsPlanShow}) => {
  const commonReducer = useSelector((state) => state?.commonReducer);
  const currentPlan = commonReducer?.currentPlan;
  const iscurrentPlanActivate = Object.keys(currentPlan).length === 0;
  const currentPlanDetails = currentPlan?.plan?.plan_detail;

  const createdAt = new Date(currentPlan?.plan?.createdAt);

  const planPurchaseDate = isNaN(createdAt.valueOf()) ? "" : `${createdAt?.getDate()}/${createdAt?.getMonth() + 1}/${createdAt?.getFullYear()}`;

  const validityValue = parseInt(currentPlanDetails?.validity, 10) || 0;
  const [remainingDays, setRemainingDays] = useState("");
  const [remainingHours, setRemainingHours] = useState(0);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(0);

  function addIntervalToPurchaseDate(planPurchaseDate, interval_count, interval_type) {
    const purchaseDate = planPurchaseDate;

    // Check if the purchase date is valid
    if (isNaN(purchaseDate)) {
      return null;
    }

    // Based on the interval_type, add to the date accordingly
    switch (interval_type) {
      case "day":
        purchaseDate.setDate(purchaseDate.getDate() + interval_count);
        break;
      case "month":
        purchaseDate.setMonth(purchaseDate.getMonth() + interval_count);
        break;
      case "year":
        purchaseDate.setFullYear(purchaseDate.getFullYear() + interval_count);
        break;
      default:
        throw new Error("Invalid interval type");
    }

    // Return date in YYYY-MM-DD format
    return purchaseDate;
  }

  const expirationDate = currentPlanDetails !== null ? addIntervalToPurchaseDate(createdAt, currentPlanDetails?.interval_count, currentPlanDetails?.interval) : new Date();

  const expirationMessage = Object.keys(currentPlan).length === 0
  ? "With scrollx watermark" : remainingDays === 0
  ? "Plan Expired" : remainingDays === 1 || validityValue === 1
  ? `Plan Expires in ${remainingHours}:${remainingMinutes}:${remainingSeconds}` : remainingDays > 1
  ? `Remaining ${remainingDays} days` : "";

  const expiryString = currentPlanDetails !== null && expirationDate !== null ? `Expiration Date ${expirationDate.getDate()}/${expirationDate.getMonth() + 1}/${expirationDate.getFullYear()}` : "";
  const renewalString = currentPlanDetails !== null && expirationDate !== null ? `Renewal Date ${expirationDate.getDate()}/${expirationDate.getMonth() + 1}/${expirationDate.getFullYear()}` : "";

  const currentDate = new Date();
  const isPlanActive = currentDate < expirationDate;

  return (
    <div className="renderBGImg w-full py-[18px] pb-[28px] rounded-lg">

      <div className=" w-[95.5%] flex justify-between pl-[45px] pt-[21px] pb-[13px] ">
        <h1 className="manrope-800  capitalize lg:text-[1.5rem] text-[0.9rem] text-white">Your Subscription Plan</h1>
        <div className=""><img className="w-5 cursor-pointer" src={info} alt="" onClick={() =>window.open(`/help/670e655049a4f8d9d08f37f5`)}/></div>
      </div>

      <div className="w-full flex justify-evenly items-center px-[2%]">

        <CurrentPlan 
          iscurrentPlanActivate={iscurrentPlanActivate}
          lable={ isPlanActive ? `${currentPlanDetails?.interval_count === 7 ? "Weekly" : currentPlanDetails?.interval_count === 30 ? "Monthly" : ""} ${currentPlanDetails?.type} Plan` : "Basic Plan"}
          currentPlan={currentPlanDetails?._id ? currentPlanDetails?.type : "Free"}
          rendersLimit={isPlanActive ? currentPlanDetails?.text1 : "Limited scroll and card renders with watermark"}
          projectLimits={isPlanActive ? currentPlanDetails?.text2 : ""}
          support={currentPlanDetails?._id ? "Support " + currentPlanDetails?.text4 : "Only support 720p"}
          validity={currentPlanDetails?._id ? "validity " + currentPlanDetails?.validity : ""}
          planRenueDate={expirationMessage}
          expiryString={expiryString}
          renewalString={renewalString}
          planPurchaseDate={planPurchaseDate}
          buttonLable={"Upgrade"}
          // onClick={() => IsUpgradeOpen(true)}
          paymentType={currentPlan?.plan?.payment_type}
          order_id={currentPlan?.plan?.order_id}
          subscription_status={currentPlan?.plan?.subscription_status}

          // Additional for test previous route flow from render 
          isPlanShow={isPlanShow}
          setIsPlanShow={setIsPlanShow}      
        />

        <CurrentPlanMoreInfoDetails
          planPurchaseDate={planPurchaseDate}
          subscription_status={currentPlan?.plan?.subscription_status}
          expiryString={expiryString}
          renewalString={renewalString}
        />

      </div>

    </div>
  )
}

export default Render_PlanCubeCard;